<template>
    <div
        class="product-description w-full z-10 bg-white pl-16 pr-8 py-12 phone:-mt-10 mobile:self-center mobile:mx-4 tablet:-mt-2 tablet:pl-24 tablet:px-12 tablet:pt-24 tabletLandscape:max-w-md tabletLandscape:mt-0 tabletLandscape:min-h-screen tabletLandscape:px-8 tabletLandscape:pl-16 tabletLandscape:pt-8 desktop:pt-18 hd:max-w-3xl">
        <svg-icon
            :key="currentProductSlug"
            :icon="getCurrentProductDescriptionProperty('icon')"
            class="text-black-700 w-36 h-28"
        />
        <h3
            class="uppercase mb-6 text-black-700 text-xl tablet:text-2xl font-bold border-t border-gold-500 pt-8 mt-8 max-w-sm"
            v-html="getCurrentProductDescriptionProperty('title')" />
        <p
            v-if="getCurrentProductDescriptionProperty('content1')"
            class="text-gray-700 text-sm tablet:text-lg tabletLandscape:text-sm desktop:text-md hd:text-lg leading-relaxed mb-8"
            v-html="getCurrentProductDescriptionProperty('content1')"
        />
        <p
            v-if="getCurrentProductDescriptionProperty('content2')"
            class="text-gray-700 text-sm tablet:text-lg tabletLandscape:text-sm desktop:text-md hd:text-lg leading-relaxed mb-8"
            v-html="getCurrentProductDescriptionProperty('content2')"
        />
        <p
            v-if="getCurrentProductDescriptionProperty('pricing')"
            class="text-sm text-black-600 border-t border-gold-500 pt-3 w-1/2">
            <span class="text-gold-500">*</span>
            {{ getCurrentProductDescriptionProperty('pricing') }}
        </p>
    </div>
</template>

<script>
import SvgIcon from '@whisper/components/icons/SvgIcon';
import { get } from 'lodash';

export default {
  name: 'PhotoGalleryProductDescriptions',
  components: {
    SvgIcon,
  },
  props: {
    products: {
      type: Object,
      required: true,
    },
    currentProductSlug: {
      type: String,
      required: true,
    },
  },
  methods: {
    getCurrentProductDescriptionProperty(property) {
      return get(this.products, [this.currentProductSlug, 'productDescription', property]);
    },
  },
};
</script>

<style scoped>

</style>
